var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"ldr-text"},[_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.loader_img,"alt":""},on:{"error":_vm.imageLoadOnError}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }